exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer{\n  background-color: #222222;\n  width: 100%;\n  min-height: 250px;\n  padding-top: 35px;\n  position: relative;\n  bottom: 0;\n}\n\n.footer-container{\n  width: 90%;\n  min-height: 180px;\n  height: auto;\n  margin: 0 auto;\n  padding: auto 0;\n  color: #fff;\n}\n\n.footer-container p{\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.footer-container span, .footer-container ul li a{\n  font-size: 10px;\n  font-weight: 300;\n  line-height: 0.5em;\n}\n\n.footer-container ul{\n  text-decoration: none;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-container ul li{\n  padding: 0;\n  margin: 0;\n  text-decoration: none;\n}\n\n.footer-container ul li a{\n  color: #fff;\n  font-weight: 300;\n}\n\n.subscribe{\n  background: linear-gradient(90deg, #ee236c, #fb602c) !important;\n  width: 100%;\n  height: 100%;\n}\n\n@media (min-width: 1281px) {\n  .footer-container p{\n    font-size: 12px;\n    font-weight: 400;\n  }\n\n  .footer-container span, .footer-container ul li a{\n    font-size: 13px;\n    font-weight: 300;\n    line-height: 0.5em;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/pages/footer/footer.component.css
// module id = ../../../../../src/app/pages/footer/footer.component.css
// module chunks = main